<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { usePlayerStore } from '~/stores/player'
import MmIcon from '../base/MmIcon.vue'
import PlayButton from '../music/PlayButton.vue'
defineProps<{ mini?: boolean; large?: boolean }>()
const { t } = useI18n()
const player = usePlayerStore()
const repeatLabel = computed(() => t(player.repeat === 'one' ? 'ux.repeatOne' : player.repeat === 'all' ? 'ux.repeatAll' : 'ux.repeatOff'))
</script>

<template>
  <div class="controls">
    <button v-if="!mini" type="button" class="icon-btn mode" :class="{ sm: !large, on: player.shuffle }" :aria-pressed="player.shuffle" :aria-label="t('ux.shuffle')" :title="t('ux.shuffle')" @click="player.toggleShuffle"><MmIcon name="shuffle" :size="large ? 22 : 18" /></button>
    <button v-if="!mini" type="button" class="icon-btn" :class="{ sm: !large }" :aria-label="t('t24a.previous')" :disabled="player.queue.length <= 1" @click="player.prev"><MmIcon name="prev" :size="large ? 28 : 18" /></button>
    <PlayButton :title="player.currentTrack?.title || ''" :size="large ? 'xl' : 'sm'" :state="player.loading ? 'loading' : player.playing ? 'playing' : 'idle'" :label="player.loading ? `${t('ux.cancelPlayback')} ${player.currentTrack?.title || ''}` : t(player.playing ? 'music.pause' : 'music.play')" cancelable @play="player.toggle" />
    <button v-if="!mini" type="button" class="icon-btn" :class="{ sm: !large }" :aria-label="t('t24a.next')" :disabled="player.queue.length <= 1" @click="player.next"><MmIcon name="next" :size="large ? 28 : 18" /></button>
    <button v-if="!mini" type="button" class="icon-btn mode" :class="{ sm: !large, on: player.repeat !== 'off' }" :aria-label="t('t24a.repeat')" :title="repeatLabel" @click="player.cycleRepeat"><MmIcon name="repeat" :size="large ? 22 : 18" /><span v-if="player.repeat === 'one'" class="one" aria-hidden="true">1</span></button>
  </div>
</template>

<style scoped>
.mode { position: relative; }
.controls .icon-btn.mode.on { color: var(--accent-text); }
.mode .one { position: absolute; top: 4px; right: 4px; min-width: 12px; height: 12px; border-radius: var(--r-pill); background: var(--accent); color: var(--accent-ink); font: 700 9px/12px var(--font-mono); text-align: center; }
</style>
